<ng-template #railTemplate let-comment let-component="component">
  <div class="comment-rail-overlay-content" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" (click)="onClickFan()" tabindex="0">
    <div
      class="comment-rail"
      (mouseenter)="onNoteHover(comment, true)"
      (mouseleave)="onNoteHover(comment, false)"
      [ngClass]="getRailTint(comment)"
    >
      @if (component.canAccept(comment)) {
        <button
          mat-mini-fab
          color="primary"
          class="folded-corner-hitarea accept-corner-button"
          type="button"
          (click)="component.onAcceptClick($event, comment)"
          [attr.aria-label]="'Accept resolution for comment by ' + getAuthorLabel(comment)"
        >
          <mat-icon>done</mat-icon>
        </button>
      } @else if (comment.accepted) {
        <!-- When accepted, show a static checkmark in the corner instead of the button -->
        <div class="folded-corner-hitarea accepted-check" aria-hidden="true">
          <mat-icon>done</mat-icon>
        </div>
      } @else {
        <div class="folded-corner-hitarea" aria-hidden="true">
          <mat-icon>block</mat-icon>
        </div>
      }

      <div
        class="comment-note"
        (focus)="onNoteHover(comment, true)"
        (blur)="onNoteHover(comment, false)"
        tabindex="0"
        [attr.data-comment-id]="getCommentId(comment)"
      >
        <div class="comment-author">{{ getAuthorLabel(comment) }}</div>

        <!-- Status pill: icon + text -->
        <div
          class="status-pill"
          [ngClass]="getStatusClass(comment)"
          *ngIf="getStatusLabel(comment)"
          (click)="component.onStatusPillClick($event, comment)"
          role="button"
          [attr.tabindex]="comment?.accepted ? -1 : 0"
          [attr.aria-disabled]="comment?.accepted"
          [attr.title]="comment?.accepted ? 'Status changes disabled — comment accepted' : 'Change status'"
          [class.status-disabled]="comment?.accepted"
        >
          <mat-icon class="status-icon" aria-hidden="true">{{ getStatusIconComment(comment) }}</mat-icon>
          <span class="status-text">{{ getStatusLabel(comment) }}</span>
        </div>
        @if (getSelectionText(comment)) {
          <div class="comment-selection">{{ getSelectionText(comment) }}</div>
        }

        <div class="comment-body">{{ comment.content }}</div>
        <div class="comment-time">{{ getCreatedAt(comment) | date: 'short' }}</div>

        @if (comment.statusChangeNotes?.length) {
          <div class="status-history">
            @for (note of comment.statusChangeNotes; track note; let i = $index) {
              <div
                class="status-history-item"
                [attr.data-note-index]="i"
                tabindex="0"
                [attr.aria-label]="component.getStatusChangeTooltip(note)"
                matTooltipClass="status-change-tooltip"
                [matTooltip]="component.getStatusChangeTooltip(note)"
                matTooltipPosition="above"
              >
                <div class="initials" aria-hidden="true">{{ component.getUserInitials(note.changedBy) }}</div>
                <div class="history-body">
                  <div class="transition">
                    <mat-icon class="transition-status {{ getStatusClassFromStatus(note.changeFrom) }}" aria-hidden="true">{{
                      getStatusIcon(note.changeFrom)
                    }}</mat-icon>
                    &nbsp;→&nbsp;
                    <mat-icon class="transition-status {{ getStatusClassFromStatus(note.changeTo) }}" aria-hidden="true">{{
                      getStatusIcon(note.changeTo)
                    }}</mat-icon>
                  </div>
                  <div class="note-preview">{{ component.previewNote(note.changeNote, 60) }}</div>
                </div>
                <div class="history-date">{{ component.formatDateDateOnly(note.changeDate) }}</div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>

<!-- template is attached to an overlay; nothing rendered here by default -->
